// Peruvian Phone number 9 Digits
export const formatPhoneNumber = (num: string) => num.replace(/\s/g, '').slice(-9);
